angular.module("EICDataStream3.queryBuilder")
  .directive('queryBuilderCheckbox', [
    function() {
      return {
        restrict: 'E',
        priority: 10, // default is 0 (ie last)
        require: 'ngModel',
        template: "\
<label ng-click='toggleValue()'\
       ng-style='pointerStyle()'\
       style='wrap: nowrap;'>\
  <i  ng-show='modelValue' \
      class='fa fa-check-square-o fa-lg' ></i>\
  <i  ng-hide='modelValue' \
      class='fa fa-square-o fa-lg'></i>\
      {{label}}\
</label>\
        ",
        scope:{
          state:      '=',
          trueValue:  '=',
          falseValue: '=',
          name:       '=',
          label:      '='
        },
        link: function(scope, element, attrs, modelCtrl) {
          scope.name = attrs.name;

          var trueValue = true;
          var falseValue = false;
          if(scope.trueValue) trueValue = scope.trueValue;
          if(scope.falseValue) falseValue = scope.falseValue;

          modelCtrl.$render = function() {
            scope.modelValue = modelCtrl.$viewValue;
          };

          scope.pointerStyle = function(){
            if(scope.state.isDisplaying){
              return {cursor:"default"};
            }
            else{
              return {cursor:"pointer"};
            }
          };

          scope.toggleValue=function(){
            if(scope.state.isDisplaying) return;

            scope.modelValue = !scope.modelValue;
            modelCtrl.$setViewValue(scope.modelValue ? trueValue : falseValue);
          };

        }
      }
    }
  ]);